import { SuccessPalette, ActionPalette, WarningPalette, ErrorPalette } from '@tcl-boron-colors/colors';
import { Direction } from './types';

export type StatusVariant = 'success' | 'warning' | 'error' | 'default';

export const PRIMARY_STATUS_COLORS: { [key in StatusVariant]: string } = {
  success: SuccessPalette[700],
  warning: WarningPalette[700],
  error: ErrorPalette[700],
  default: ActionPalette[400],
};

export const SECONDARY_STATUS_COLORS: { [key in StatusVariant]: string } = {
  success: SuccessPalette[100],
  warning: WarningPalette[100],
  error: ErrorPalette[100],
  default: ActionPalette[100],
};

export const ARROW_KEYS = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'] as const;

export const ACTION_KEYS = [' ', 'Enter'] as const;

export const ARROW_KEY_TO_DIRECTION_MAPPING: { [k in typeof ARROW_KEYS[number]]: Direction } = {
  ArrowLeft: 'Backward',
  ArrowRight: 'Forward',
  ArrowUp: 'Backward',
  ArrowDown: 'Forward',
};
